export default __webpack_public_path__ + "night-stork-bg-1920x1080.f578646.svg";